/* eslint indent: 0 */
import './video_thumbnail_picker.less';

import Backbone from 'backbone';

import videoThumbnailPickerTemplate from './video_thumbnail_picker.tpl';

const VideoThumbnailPickerView = Backbone.View.extend({

    className: 'video-thumbnail-picker-view defaultModal modal hide',

    attributes: {
      // Copied from the video.mako old school template
      tabindex: '-1',
      role: 'dialog',
      'aria-labelledby': 'thumbnailPickerModal',
      'aria-hidden': 'true'
    },
 
    template: videoThumbnailPickerTemplate,

    events: {
      'click .action-choose-thumbnail': 'handleChooseThumbnail',
      'hidden.bs.modal': 'onHidden',
      'shown.bs.modal': 'onShown',
      'load img': 'onLoad'
    },

    initialize: function(options) {

      if (options.asset) {
        this.asset = options.asset;
      } else {
        throw new Error('Must specify an `asset` of type `MediaLibraryAsset`');
      }

      this.defer = $.Deferred();
      this.selectedImageSrc = (
        options.selectedImageSrc || 
        (this.model && this.model.get('tile_display_image')) ||
        this.asset.get('displayImage')
      );
    },

    //// Renderers

    render: function() {
            
      this.$el.html(this.template({
        selectedImageSrc: this.selectedImageSrc,
        assetData: this.asset.attributes
      }));

      this.$('.modal-body').css({ 'min-height':'440px' });

      return this;
    },

    
    onLoad: function() {
      this.$el.trigger('resize');
    },

    //// User event action handlers

    handleChooseThumbnail: function(e) {
      var thumbnailSrc = $(e.currentTarget).attr('data-thumbnail-src');

      this.asset.saveVideoThumbnail(thumbnailSrc)

        .done(function() {
          this.defer.resolve(thumbnailSrc);
          this.$el.modal('hide');          
        }.bind(this));

    },

    onHidden: function() {
      this.remove();
    },

    onShown: function() {
      this.$el.trigger('resize');
    }


  }, {

    show: function(options) {
      var view = new VideoThumbnailPickerView(options);

      view.render().$el.modal('show');

      return view.defer.promise();
    }

  });



export default VideoThumbnailPickerView;
